import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import icons from 'icons'

import colors from './colors'

const EditIcon = icons.edit
const DeleteIcon = icons.delete

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(1),
    padding: theme.spacing(3),
    cursor: 'move',
  },
  container: ({color}) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-top',
    '& .color': {
      flexGrow: 0,
      textAlign: 'left',
      marginRight: theme.spacing(2),
      '& .square': {
        width: '50px',
        height: '50px',
        border: '1px solid #000000',
        backgroundColor: colors[color],
        boxShadow: '5px 5px 10px 0px rgba(0,0,0,0.15)',
      },
    },
    '& .threshold': {
      flexGrow: 0,
      width: '100px',
      minWidth: '100px',
      textAlign: 'left',
      color: '#ccc',
      '& p': {
        fontWeight: ['bold', '!important'],
        fontSize: ['2em', '!important'],
      }
    },
    '& .text': {
      flexGrow: 1,
      textAlign: 'left',
    },
    '& .actions': {
      flexGrow: 0,
      textAlign: 'right',
      minWidth: '200px',
      width: '200px',
    }
  }),
}))

const Item = ({
  item,
  onEdit,
  onDelete,
}) => {
  const color = item.color || 'amber'
  const classes = useStyles({color})
  return (
    <Paper className={ classes.root }>
      <div className={ classes.container }>
        <div className="color">
          <div className="square">
          </div>
        </div>
        <div className="threshold">
          <Typography>
            { item.threshold || '0' }
          </Typography>
        </div>
        <div className="text">
          <Typography>
            { item.text }
          </Typography>
        </div>
        <div className="actions">
          <Button
            size="small"
            variant="contained"
            onClick={ () => onDelete(item) }
          >
            Delete&nbsp;<DeleteIcon />
          </Button>
          &nbsp;&nbsp;&nbsp;
          <Button
            size="small"
            variant="contained"
            onClick={ () => onEdit(item) }
          >
            Edit&nbsp;<EditIcon />
          </Button>
        </div>
      </div>
    </Paper>
  )
}

export default Item